module.exports = __webpack_public_path__ + "img/biter-attack-3.e04a58ee.png";